//#region
import { useEffect } from 'react';
//material
import { Grid } from '@mui/material';
// component
import Controls from '../../controls/Controls';
import { useForm, Form } from "../../useForm"
//#endregion

const initialFValues = {
  _id: 0,
  dataSetName: '',
  databaseName: '',
  sql: '',
  tableAlias: '',
  tableName:''
}

export default function DatasetsPopup(props) {
  const { addOrEdit, recordForEdit } = props

  const validate = (fieldValues = values) => {
    let temp = { ...errors }
    if ('dataSetName' in fieldValues) {
      temp.dataSetName = fieldValues.dataSetName ? "" : "This field is required."
    }
    
    setErrors({
        ...temp
    })
      
    if (fieldValues === values)
        return Object.values(temp).every(x => x === "")
  }

  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInputChange,
    resetForm
  } = useForm(initialFValues, true, validate);

  const handleSubmit = e => {
    e.preventDefault()
    if (validate()) {
        addOrEdit(values, resetForm);
    }
  }
  
  useEffect(() => {
        if (recordForEdit != null)
            setValues({
                ...recordForEdit
            })
  }, [recordForEdit, setValues])


  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={6}>
          <Controls.Input
              name="dataSetName"
              label="Dataset Name"
              value={values.dataSetName}
              onChange={handleInputChange}
              error={errors.datasetName}
          />
          <Controls.Input
              name="sql"
              label="Sql Name"
              value={values.sql}
              onChange={handleInputChange}
              error={errors.sql}
          />
          <Controls.Input
              name="tableAlias"
              label="Table Alias"
              value={values.tableAlias}
              onChange={handleInputChange}
              error={errors.tableAlias}
          />
        </Grid>
        <Grid item xs={6}>
          <Controls.Input
              label="DataBase Name"
              name="databaseName"
              value={values.databaseName}
              onChange={handleInputChange}
              error={errors.databaseName}
          />
          <Controls.Input
              label="Table Name"
              name="tableName"
              value={values.tableName}
              onChange={handleInputChange}
              error={errors.tableName}
          />
          <div>
            <Controls.Button
              className="report_form_ui_btn cancel mr-2"
              color="secondary"
              text="Reset"
              onClick={resetForm}
            />
            <Controls.Button
              className="report_form_ui_btn submit"
              type="submit"
              text="submit"
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  )
}